import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, useTheme } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import * as send from '../../../../../lib/analytics/send';

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange, setOffset, offset, estimatedResults, setPage, setBanner, isPremium, isLoading, activePresetName } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
    send.uevent(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    if (!isPremium) {
      setBanner(true)
      return;
    }
    if (page >= Math.ceil(count / rowsPerPage) - 1 && estimatedResults > 100 && isPremium) {
      // setOffset(offset + 100)
      setOffset(offset + rowsPerPage)
      setPage(page + 1)
      send.uevent(event, page + 1);
    } else {
      onPageChange(event, page + 1);
      send.uevent(event, page + 1);
    }
  };

  const handleLastPageButtonClick = (event) => {
    if (page >= Math.ceil(count / rowsPerPage) - 1) {
      setOffset(offset + 100)
    } else {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    }
  };

  return (
    <div className="table-pagination" style={{ flexShrink: 0, marginLeft: '16px', display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0 || isLoading}
        aria-label="previous page"
        size="small"
        data-event-name="table-pagination"
        data-event-category="stock-screener"
        data-event-label={`${activePresetName}-previous-page-${page - 1}`}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(estimatedResults / rowsPerPage) - 1 || isLoading}
        aria-label="next page"
        size="small"
        data-event-name="table-pagination"
        data-event-category="stock-screener"
        data-event-label={`${activePresetName}-next-page-${page + 1}`}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default TablePaginationActions;
